import React from "react";

function HollowTableRow({ children, onClick }) {
  return (
    <tr onClick={onClick}>
      {children.map((child) => (
        <td>{child}</td>
      ))}
    </tr>
  );
}

export default HollowTableRow;
